import { Mode, Type } from "../Form";
import { TextField } from "../TextField/TextField";
import { TextFieldComponent } from "../TextField/TextFieldComponent";
import styles from "./LongText.module.scss";

type Options = {question?: string, answer?: string, renderId?: string, required?: boolean};

export class LongText extends TextField {
  constructor(options?: Options) {
    super({...(options ?? {}), type: Type.LongTextField});
  }

  render(mode: Mode, onElementChange: (element: LongText) => void): JSX.Element {
    return <TextFieldComponent multiline key={this.renderId} mode={mode} onElementChange={onElementChange} element={this} />
  }
}